import { useCallback } from 'react'
import { compact } from 'lodash'
import { useSpreadsheet } from 'hooks/useSpreadsheet'

export const useExportReports = (peers, criterias) => {
  const { exportFile } = useSpreadsheet()

  const getRange = (values) => {
    return compact(values)
      .map((val) => parseFloat(val).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))
      .join(' - ')
  }

  const exportToSpreadsheet = useCallback(() => {
    const formattedPeers = peers?.reduce((acc, curr) => {
      const {
        organization: { peerComparisonFactor, type, name },
        orgName,
      } = curr
      let peer = orgName ? [orgName] : [name]
      criterias.forEach(({ value }) => {
        switch (value) {
          case 'awardRange':
            const { scholarshipMinimumAward, scholarshipMaximumAward } =
              peerComparisonFactor
            peer.push(
              getRange([scholarshipMinimumAward, scholarshipMaximumAward])
            )
            break
          case 'age':
            const { minAge, maxAge } = peerComparisonFactor
            peer.push(getRange([minAge, maxAge]))
            break
          case 'totalOverhead':
          case 'totalPayroll':
          case 'totalDollarAmount':
            peer.push(getRange([curr[value]]))
            break
          case 'totalAwardAmount':
            const { totalAwardAmount } = peerComparisonFactor
            peer.push(getRange([totalAwardAmount]))
            break
          case 'organizationType':
            peer.push(type)
            break
          default:
            peer.push(curr[value] || peerComparisonFactor[value])
            break
        }
      })
      acc.push(peer)
      return acc
    }, [])

    //Create an array of arrays with the headers as first row
    const data = [
      ['Organization Name', ...criterias.map(({ label }) => label)],
      ...formattedPeers,
    ]
    data.length > 1 && exportFile(data, 'report')
  }, [peers, criterias, exportFile])

  return {
    exportToSpreadsheet,
  }
}
